/**
 * Funnel token storage.
 * Guarda o token de resgate da transcrição do funil público entre
 * a landing page (/transcrever-instagram) e o pós-cadastro/assinatura.
 */

const FUNNEL_TOKEN_KEY = 'thecontent_funnel_token';
const FUNNEL_LAST_TRY_KEY = 'thecontent_funnel_last_try';
const FUNNEL_CONTEXT_KEY = 'thecontent_funnel_context';

export const INSTAGRAM_TRANSCRIPTION_FUNNEL = 'instagram-transcription';

export type FunnelContext = {
  source: typeof INSTAGRAM_TRANSCRIPTION_FUNNEL;
  previewText: string;
  mediaType?: string | null;
  owner?: string | null;
  createdAt: number;
};

export function getFunnelToken(): string | null {
  return sessionStorage.getItem(FUNNEL_TOKEN_KEY);
}

export function setFunnelToken(token: string): void {
  sessionStorage.setItem(FUNNEL_TOKEN_KEY, token);
}

export function clearFunnelToken(): void {
  sessionStorage.removeItem(FUNNEL_TOKEN_KEY);
  sessionStorage.removeItem(FUNNEL_LAST_TRY_KEY);
  sessionStorage.removeItem(FUNNEL_CONTEXT_KEY);
}

export function setFunnelContext(context: Omit<FunnelContext, 'createdAt'>): void {
  sessionStorage.setItem(
    FUNNEL_CONTEXT_KEY,
    JSON.stringify({ ...context, createdAt: Date.now() })
  );
}

export function getFunnelContext(): FunnelContext | null {
  const raw = sessionStorage.getItem(FUNNEL_CONTEXT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as FunnelContext;
    if (parsed.source !== INSTAGRAM_TRANSCRIPTION_FUNNEL || !parsed.previewText) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearFunnelContext(): void {
  sessionStorage.removeItem(FUNNEL_CONTEXT_KEY);
}

/** Evita retry de claim em loop: mín. 30s entre tentativas. */
export function canRetryClaim(): boolean {
  const last = Number(sessionStorage.getItem(FUNNEL_LAST_TRY_KEY) || 0);
  return Date.now() - last > 30_000;
}

export function markClaimAttempt(): void {
  sessionStorage.setItem(FUNNEL_LAST_TRY_KEY, String(Date.now()));
}
